import { cn } from '@/lib/utils';
import { useEffect, useState } from 'react';
import { Sheet, SheetContent, SheetHeader } from '@/components/ui/sheet';
import { Checkbox } from '@/components/ui/checkbox';
import { useTranslation } from 'react-i18next';
import { OrderType } from '../../typing';
import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';
import { useAppStore } from '@/store';

interface IProps {
  orderType: OrderType;
  onChangeOrderType: (type: OrderType) => void;
}

export default (props: IProps) => {
  const { orderType, onChangeOrderType } = props;
  const { fwClass } = useAppStore();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const onCheck = (type: OrderType) => {
    onChangeOrderType(type);
    setOpen(false);
  };

  const { subscribe } = useAppEventBusContext();

  useEffect(() => {
    const unsubscribe = subscribe(SubscribeEvent.Open_Order_Type_Modal, setOpen);
    return () => unsubscribe();
  }, []);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="bottom" hideCloseIcon className="h-[145px] p-[16px] border-t-[1px] border-t-borderColor">
        <SheetHeader hidden></SheetHeader>
        <div className="flex flex-col gap-y-[20px]">
          <div className="flex justify-between" onClick={() => onCheck('market')}>
            <span className={cn('text-[16px]', fwClass)}>{t('Trade.market')}</span>
            <Checkbox className="rounded-full size-[20px]" checked={orderType == 'market'} />
          </div>
          <div className="flex justify-between" onClick={() => onCheck('limit')}>
            <span className={cn('text-[16px]', fwClass)}>{t('Trade.limit')}</span>
            <Checkbox className="rounded-full size-[20px]" checked={orderType == 'limit'} />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
